import React from "react";
import "./WorkAreaSection.css";
import babyImage from "../../assets/images/baby.webp";
import { Link } from 'react-router-dom';

const WorkAreaSection = () => {
  const locationGroups = [
    {
      title: "Den Haag & Omgeving",
      locations: ["Den Haag", "Leidschendam", "Voorburg", "Rijswijk", "Wassenaar", "Voorschoten"],
    },
    {
      title: "Delft & Westland",
      locations: ["Delft", "Pijnacker", "Nootdorp", "Westland", "Naaldwijk", "Monster"],
    },
    {
      title: "Rotterdam & Omgeving",
      locations: ["Rotterdam", "Schiedam", "Vlaardingen", "Maassluis"],
    },
    {
      title: "Leiden & Omgeving",
      locations: ["Leiden", "Leiderdorp", "Oegstgeest", "Zoetermeer"],
    }
  ];

  return (
    <section className="workarea-section">
      <div className="workarea-hero">
        {/* Background Image */}
        <div className="workarea-hero-bg">
          <img src={babyImage} alt="Liebevolle kraamzorg voor baby en gezin" />
          <div className="workarea-hero-overlay"></div>
        </div>
        
        {/* Content Overlay */}
        <div className="workarea-hero-content">
          <div className="workarea-badge">
            <span>📍 Ons Werkgebied</span>
          </div>
          <h2 className="workarea-hero-title">
            Kraamzorg Bee is actief in regio Zuid-Holland
          </h2>
          <p className="workarea-hero-subtitle">
            Wij bieden persoonlijke kraamzorg in de mooiste regio's van Zuid-Holland
          </p>
        </div>
      </div>

      <div className="workarea-content-section">
        <div className="workarea-container">
          <div className="workarea-intro">
            <p>
              Onze ervaren kraamverzorgenden kennen de omgeving goed en zijn snel ter plaatse 
              wanneer u ons nodig heeft. Zo kunnen wij jou en je gezin de beste zorg bieden, dichtbij huis.
            </p>
          </div>

          {/* Location Cards Grid */}
          <div className="workarea-cards-grid">
            {locationGroups.map((group, index) => (
              <div key={index} className={`workarea-location-card workarea-card-${index + 1}`}>
                <div className="workarea-card-header">
                  <h3 className="workarea-group-title">{group.title}</h3>
                </div>
                <div className="workarea-location-list">
                  {group.locations.map((location, locationIndex) => (
                    <div key={locationIndex} className="workarea-location-item">
                      <div className="workarea-location-dot"></div>
                      <span className="workarea-location-name">{location}</span>
                    </div>
                  ))}
                </div>
                <div className="workarea-card-hover-effect"></div>
              </div>
            ))}
          </div>

          <div className="workarea-closing">
            <div className="workarea-closing-content">
              <h3>Woon je net buiten deze regio?</h3>
              <p>
                Neem dan gerust contact met ons op. We kijken graag samen naar de mogelijkheden 
                om jou toch te ondersteunen. Bij Kraamzorg Bee denken we in oplossingen en doen 
                we ons best om iedereen te helpen, waar dat kan.
              </p>
              <Link to="/contact" className="workarea-cta-button">
                <span>Contact opnemen →</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkAreaSection;
